export default "__VITE_ASSET__DpgBcjCL__"